import { uri } from '../../api-endpoint';
import { deleteTemplateFn } from '../common';

export const deleteModel = (token: string) => (modelId: number) =>
  deleteTemplateFn(token, uri.modelById(modelId));
